import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next";
import MainLinks from "../components/navlinks/MainLinks";
import Body from "../components/body/BodyPage";
import { MDBAlert, MDBBreadcrumb, MDBBreadcrumbItem, MDBBtn, MDBCard, MDBCardBody, MDBCardText, MDBCardTitle, MDBChip, MDBChipsInput, MDBCol, MDBDatatable, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBRow, MDBScrollspy, MDBScrollspyLink, MDBSpinner } from "mdb-react-ui-kit";
import { Tooltip } from "react-tooltip";
import { useLocation, useNavigate } from "react-router";
import { getMisc, getOrganizationsData, getOrgSpecifcPoolsData, updateOrgPool } from "../apiclients/streamsapi_bridge";
import { AddRemoveNumbers, formattedNumber } from "./popups/phonenumbers/AddRemoveNumbers";
import PopupLoader from "./popups/PopupLoader";
import TopSuccess from "../components/header/TopSuccess";
import TopMessage from "../components/header/TopMessage";
import UnassignPhNumbers from "./popups/orggroups/UnassignPhNumbers";
import { useFieldArray, useForm } from "react-hook-form";
import SaveChanges from "../components/topviews/saveCancel";
import PopupLoaderNew from "./popups/PopupLoaderNew";
import { useAdminContext } from "../components/adminstore/Admin-Context";
import EditWarning from "../components/header/EditWarning";
import { customSearch, useAutoFocusSearchAfterLoads } from "../components/CustomSearchUtil/CustomSearch";
import UIConstant from "../apiclients/UIConstant";

export default function PoolEdit() {


    const location = useLocation();
    const stateData = location?.state;
    const [PoolObjInfo, setPoolObjInfo] = useState(stateData ?? {});
    const [isloading, setIsloading] = useState(false);
    const [internalError, setInternalError] = useState(false);
    const [AddNumbers, setAddNumbers] = useState(false);
    const toggleNumbers = () => setAddNumbers(!AddNumbers);
    const [availableAddNums, setAvailableAddNums] = useState([]);
    const [targePhonenumbers, setTargetPhonenumbers] = useState([]);
    const [updatedPHnums, setUpdatedPHnums] = useState([]);
    const [updatedPHnumsFlag, setUpdatedPHnumsFlag] = useState(false);
    const [successMessage, setSuccessMessage] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const { isEdited, setEdited } = useAdminContext();
    const [targetView, setTargetView] = useState("");
    const [showWarning, setShowWarning] = useState(false);
    const warningToggle = () => setShowWarning(!showWarning);
    const navigate = useNavigate();

    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();

    const section1 = useRef(null);
    const containerRef = useRef(null);

    const [basicModal, setBasicModal] = useState(false);

    const toggleOpen = () => setBasicModal(!basicModal);

    const [listPoolDetails, setListPoolDetails] = useState([]);

    const [refreshListPoolData, setRefreshListPoolData] = useState(false);


    const [poolName, setPoolName] = useState(PoolObjInfo?.pool_name);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);

    useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef)

    // Unassigning the phonenumber.
    const [delPhNumber, setDelPhNumber] = useState(null);

    const [removedPhNumber, setRemovedPhNumber] = useState(null);

    const [unassignFlag, setUnassignFlag] = useState(false);

    const unassignTogglePopup = () => setUnassignFlag(!unassignFlag);
    const [removedSuccess, setRemovedSuccess] = useState(false);
    const [backendPoolNameError, setBackendPoolNameError] = useState("");
    const [rowsData, setRowsData] = useState([]);
    const [searchValue, setsearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    // alias name change cases.
    const {
        register,
        control,
        reset,
        formState: { dirtyFields, isDirty, errors },
        handleSubmit,
        watch
    } = useForm({
        defaultValues: { aliases: listPoolDetails, poolName: poolName },
    });
    const { fields } = useFieldArray({
        control,
        name: "aliases"
    });


    const addNumberRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);

    function handleClick() {
        addNumberRef.current.click();
    }

    useEffect(() => {
        if (successMessage != null && successMessage?.toString().trim() != '') {
            console.log(`Succes coming heree....${successMessage}`);
            setSuccessMessage(successMessage);
            setTimeout(() => {
                setSuccessMessage(null);
            }, 10000);
        }
    }, [successMessage]);

    const handleOk = () => {
        setEdited(false);
        if (targetView.indexOf("/") !== -1) {
            navigate(targetView);
        }
        setShowWarning(false);
    };





    async function getOrganizationsSpecifcPoolsData(PoolInfoObj = {}) {
        try {
            setIsloading(true);
            const response = await getOrgSpecifcPoolsData(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid, PoolInfoObj.poolid
            );
            setTimeout(() => {
                setIsloading(false);
            }, 1000);
            const allOrgGrpData = await response.json();
            console.log(`allOrgData:::${JSON.stringify(allOrgGrpData)}`);
            if (response.status == 200) {
                let poolDtls = allOrgGrpData.pool_details ?? {};
                setTargetPhonenumbers(poolDtls.pool_dids?.map(obj => obj.phone_number));
                setListPoolDetails(poolDtls.pool_dids);
                reset({ aliases: poolDtls.pool_dids, poolName: poolDtls.pool_name });
                setPoolName(poolDtls.pool_name);
                setRefreshListPoolData(false);
            } else {
                setInternalError(true);
            }

        } catch (error) {
            console.log(`Unable to process getAllPoolDetails:${error}`);
            setInternalError(true);
        }
    }
    useEffect(() => {
        // fetching the pool associated number details.
        if (Object.keys(PoolObjInfo ?? {}).length > 0 || refreshListPoolData == true) {
            setPoolName(poolName ?? PoolObjInfo.pool_name);
            getOrganizationsSpecifcPoolsData(PoolObjInfo);

        }
    }, [PoolObjInfo, refreshListPoolData]);


    const actionData = {
        columns: [
          { label: "Phone Number(s)", field: "phnumber", sort: true },
          { label: "State ", field: "state" },
          { label: "Route to ", field: "assignedto" },
          { label: "Name ", field: "assignedname" },
          { label: "Location", field: "location_name" },
          { label: "Alias", field: "Alias" },
          ...(PoolObjInfo.pool_name !== "Default Pool"
            ? [{ label: "Unassign ", field: "Unassign", sort: false }]
            : []),
        ],
        rows: rowsData,
      };
      

    function unassignNumber(e, phnumber) {
        e.preventDefault();
        e.stopPropagation();
        setDelPhNumber(phnumber);
        setRemovedPhNumber(phnumber);
        unassignTogglePopup();
    }
    function addFieldsToUI() {
        try {
            console.log(`Fields arrray lentht::${fields.length}`);
            if (fields.length > 0) {
                const uiDataRowsArray = fields.map((obj, index) => {

                    let phNumber = obj.phone_number ? formattedNumber(obj.phone_number) + "" : "";
                    return {
                        phnumber: phNumber,
                        actualData: phNumber?.toString().replace(/[ ]/g, ''),
                        state: obj.state_name,
                        assignedto: obj.assigned_to,
                        location_name: obj.location_name,
                        assignedname: obj.name,
                        Alias: (
                            <>
                                <input
                                    type="text"
                                    name={`aliases[${index}].alias_name`}
                                    maxLength={16}
                                    className="form-control selectname-small"
                                    {...register(`aliases[${index}].alias_name`)}
                                />
                            </>
                        ),
                        Unassign: (
                            <>
                                <div className="d-flex align-items-center justify-content-center">
                                    <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip">
                                        <MDBIcon fas icon="unlink"
                                            color="primary"
                                            className="m-1 unassign"
                                            onClick={(e) => { unassignNumber(e, obj.phone_number); }} />
                                    </div>
                                </div>
                            </>
                        )
                    }


                });
                setRowsData(uiDataRowsArray);
                setFilteredRows(uiDataRowsArray)
               
            }


        } catch (e) {
            console.log(`settings fieldinfo error:${e}`);
        }
    }
    useEffect(() => {
        addFieldsToUI();
         setDataLoaded(true)
    }, [fields]);

    // listPoolDetails.forEach((obj, index) => {
    //     let phNumber = obj.phone_number ? formattedNumber(obj.phone_number) + "" : "";
    //     actionData.rows.push({
    //         phnumber: phNumber,
    //         actualData: phNumber?.toString().replace(/[ ]/g, ''),
    //         state: obj.state_name,
    //         assignedto: obj.assigned_to,
    //         location_name: "Tiger",
    //         assignedname: obj.name,
    //         Alias: (
    //             <>
    //                 <input
    //                 type="text"
    //                 name={`aliases[${index}].`}
    //                 maxLength={16}
    //                 className="form-control selectname-small"
    //                 {...register(`aliases[${index}].label`)}
    //                 />
    //             </>
    //         ),
    //         Unassign: (
    //             <>
    //                 <div className="d-flex align-items-center justify-content-center">
    //                     <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip">
    //                         <MDBIcon fas icon="unlink" 
    //                             color="primary" 
    //                             className="m-1 unassign" 
    //                             onClick={(e)=>{unassignNumber(e,obj.phone_number); }} />
    //                     </div>
    //                 </div>
    //             </>
    //         )
    //     });
    // });



    async function getMiscOrgInfo() {
        try {
            const apiResponse = await getMisc(JSON.parse(sessionStorage.getItem("admin_session")).siteid, { misc: ["orgpool_freedids"], poolid: PoolObjInfo.poolid });
            if (!apiResponse.json) {
                const message = `An error has occured: ${apiResponse.statusText}`;
                return;
            }
            const apiInfo = await apiResponse.json();
            console.log(`MISCC APIInfo::${apiInfo?.misc?.orgpool_freedids?.map(obj => obj.phone_number)}`);
            setAvailableAddNums(apiInfo?.misc?.orgpool_freedids?.map(obj => obj.phone_number));
        } catch (e) {
            console.log(`Org Info not available:${e}`);
        }
    }

    async function addPhoneNumber() {
        getMiscOrgInfo();
        toggleNumbers();
    }


    //sending update request.
    async function updatePoolEditData(poolInfoObj, updateAliases = {}) {
        setUnassignFlag(false);
        try {
            if (Object.keys(poolInfoObj).length > 0) {
                let updateJSON = {
                    reqid: 115,
                    poolid: poolInfoObj.poolid,
                    siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                };
                if (updatedPHnums?.length > 0) {
                    Reflect.set(updateJSON, "add_dids", updatedPHnums.map((num) => parseInt(num)));
                }
                if (removedPhNumber != null && removedPhNumber != 0) {
                    Reflect.set(updateJSON, "remove_dids", [parseInt(removedPhNumber)]);
                }
                if (Object.keys(updateAliases).length > 0) {
                    updateJSON = { ...updateJSON, ...updateAliases };
                }
                console.log(`UpdateJSONInof:::${JSON.stringify(updateJSON)}`);
                setIsloading(true);
                // sending update request.
                let apiResponse = await updateOrgPool(updateJSON);
                setTimeout(() => { setIsloading(false) }, 1000);
                let apiData = await apiResponse.json();
                console.log(`status::${apiResponse.status} ::`);
                if (apiResponse.status == 200) {
                    // let apiData = await apiResponse.json();
                    console.log(`status MEssage:${apiData.message}`);
                    setSuccessMessage(apiData.message);
                    setPoolName(updateJSON.pool_name ?? poolName);
                       setRefreshListPoolData(true); //only success then refresh 
                       onCloseChanges(); //only success then close

                } 
                else if(apiData?.message?.errors) {
                    apiData.message.errors.forEach((err) => {
                        if(err.param_name === "pool_name") {
                            setBackendPoolNameError(err.message); // Set backend error
                        }
                    });
                }
                else {
                    setErrorMessage('Unable to process the request.');
                }
                setUpdatedPHnumsFlag(false);
                setRemovedPhNumber(null);
                // setRefreshListPoolData(true);
                // onCloseChanges();
            }

        } catch (e) {
            console.log(`Org Info not available:${e}`);
        }
    }

    useEffect(() => {
        if (updatedPHnumsFlag == true || removedSuccess == true) {
            // adding DIDs.
            updatePoolEditData(PoolObjInfo);

        }
    }, [updatedPHnumsFlag, removedSuccess]);


    useEffect(() => {
        setEdited(isDirty);

    }, [isDirty])


    const onsaveChanges = async (formdata) => {
        try {
            //we need to prepare api request parameters for only dirty fields in formdat
            let updateAliases = {};
            let editAliases = [];
            console.log(`dirtyFields::${dirtyFields}`);
            if (isDirty && Object.keys(dirtyFields).length > 0 && dirtyFields.aliases) {
                Object.keys(dirtyFields.aliases).map((key) => {
                    let jsonObj = formdata.aliases[key];
                    editAliases.push({
                        phnumber: jsonObj.phone_number,
                        alias_name: jsonObj.alias_name
                    });
                });
            }
            if (editAliases.length > 0) {
                updateAliases["update_alias"] = editAliases;
            }
            if (dirtyFields.poolName) {
                updateAliases.pool_name = formdata.poolName;
            }
            console.log(`Onsave changesss::${JSON.stringify(editAliases)}::Name::${dirtyFields.poolName ? formdata.poolName : 'no -edit'}`);

            updatePoolEditData(PoolObjInfo, updateAliases);

        } catch (e) {
            console.log("Error in onsaveChanges :" + e);
        }
    };
    const onCloseChanges = () => {
        console.log("usersInGroup ::::::  " + JSON.stringify(listPoolDetails));
        setBackendPoolNameError("") //if we click cancel again error should clear
        reset({ aliases: listPoolDetails, poolName: poolName });
    };



    const handleManualSearch = (searchValue) => {
        setsearchValue(searchValue);
        const filteredUsers = customSearch(rowsData, searchValue, UIConstant.POOL_EDIT);

        setFilteredRows(filteredUsers);
    };


    return (
        <React.Fragment>
            <>
                <MainLinks active={6} />
                <Body
                    tablinks={6}
                    sublink={282}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header py-3 ps-0">
                                        <h5 className="mb-0 ">
                                            <MDBBreadcrumb>
                                                <MDBBreadcrumbItem>
                                                    <a onClick={(e) => {
                                                        if (isEdited) {
                                                            setTargetView("/accountinfolanding");
                                                            setShowWarning(true);
                                                            return;
                                                        }
                                                        navigate("/accountinfolanding");
                                                    }}>
                                                        <strong>Admin Tools</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem active>
                                                    <a
                                                        onClick={(e) => {
                                                            if (isEdited) {
                                                                setTargetView("/orggroupslandingpage");
                                                                setShowWarning(true);
                                                                return;
                                                            }
                                                            navigate("/orggroupslandingpage");
                                                        }}
                                                    >
                                                        <strong>Org Groups</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem>
                                                    <a href="">
                                                        <strong>{poolName}</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                            </MDBBreadcrumb>
                                        </h5>
                                    </div>
                                    <div className="card-body px-0">
                                        <div className="pb-2">
                                            <h5 className="fw-600 mt-2 ">
                                                {poolName}
                                            </h5>
                                        </div>
                                        <div className="routing-border pt-0 my-2"></div>



                                        <MDBCard className='p-0 col-md-6 tab-w-70 shadow-none mob-w-100'>
                                            <MDBCardBody className=' rounded bg-info bg-opacity-10'>
                                                <div>
                                                    <MDBCardTitle className='mb-0'>General settings</MDBCardTitle>
                                                </div>
                                                <div className="add-numbermain mt-0">
                                                    <div className="tel-numbers">Pool Name</div>
                                                    <div className="d-flex">
                                                        <div className="phoneselect">
                                                            <input
                                                                maxLength={100}
                                                                type="text"
                                                                disabled = {watch("poolName") === "Default Pool"}
                                                                className="selectname"
                                                                {...register("poolName", { 
                                                                    required: "Pool Name is required",
                                                                    onChange: () => setBackendPoolNameError("") // Clear on typing
                                                                })}
                                                            />
                                                            {(errors.poolName || backendPoolNameError) && (
                                                                <p className="text-danger">
                                                                    {errors.poolName?.message || backendPoolNameError}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>                                                 
                                                </div>
                                            </MDBCardBody>
                                        </MDBCard>





                                        <div className="mt-4">
                                            <div className="actionbar">
                                                <MDBBtn onClick={addPhoneNumber}><MDBIcon fas icon="plus" color="light" /> Add Numbers</MDBBtn>
                                            </div>

                                            <div className='mb-2 mt-3 position-relative w-auto'>
                                                <MDBInput ref={searchRef} label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
                                                <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                                            </div>
                                            <div className="actioncolumn orgpoolsdetailsDt">
                                                <MDBDatatable
                                                    key={searchValue}
                                                    fixedHeader
                                                    entries={50}
                                                    maxHeight="63vh"
                                                    hover sortField="Phone Number(s)"
                                                    data={{...actionData,
                                                        rows:filteredRows
                                                    }}
                                                     />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <MDBModal open={basicModal} onClose={() => setBasicModal(false)} tabIndex='-1'>
                                <MDBModalDialog>
                                    <MDBModalContent>
                                        <MDBModalHeader>
                                            <MDBModalTitle>Add Pools</MDBModalTitle>
                                            <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
                                        </MDBModalHeader>
                                        <MDBModalBody>
                                            <div className="position-relative mb-3">
                                                <div className="form-outline">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search"
                                                    />
                                                </div>
                                                <MDBIcon
                                                    fas
                                                    icon="search"
                                                    className="custom-search_icon"
                                                />
                                            </div>

                                            <div className="mt-2">
                                                <div className="chips chips-placeholder d-flex align-items-center flex-wrap">
                                                    <MDBChip closeIcon>Harish Marella</MDBChip>
                                                    <MDBChip closeIcon>Chinna</MDBChip>
                                                    <MDBChip closeIcon>Kowshal</MDBChip>
                                                    <MDBChip closeIcon>Ben</MDBChip>
                                                </div>
                                            </div>
                                            <div className="routing-border p-0 my-4"></div>

                                            <div className="position-relative mb-2">
                                                <div className="form-outline">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search"
                                                    />
                                                </div>
                                                <MDBIcon
                                                    fas
                                                    icon="search"
                                                    className="custom-search_icon"
                                                />
                                            </div>
                                            <p ><a className="text-small" href="">Select All</a></p>

                                            <div className="mt-2">
                                                <div className="chips chips-placeholder d-flex align-items-center flex-wrap">
                                                    <MDBChip>Harish Marella</MDBChip>
                                                    <MDBChip>Chinna</MDBChip>
                                                    <MDBChip>Kowshal</MDBChip>
                                                    <MDBChip>Ben</MDBChip>
                                                </div>
                                            </div>
                                        </MDBModalBody>

                                        <MDBModalFooter>
                                            <MDBBtn color='secondary' onClick={toggleOpen}>
                                                cancel
                                            </MDBBtn>
                                            <MDBBtn>Add</MDBBtn>
                                        </MDBModalFooter>
                                    </MDBModalContent>
                                </MDBModalDialog>
                            </MDBModal>
                        </>
                    }
                />

                <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                    Unassign
                </Tooltip>
                {
                    isloading && (
                        <>
                            <div className="loadingclass">
                                <MDBBtn disabled>
                                    <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                    Loading...
                                </MDBBtn>
                            </div>
                        </>
                    )
                }
                {internalError && (
                    <MDBAlert
                        open
                        className="alert-center"
                        color="danger"
                        autohide
                        position="top-center"
                        delay={5000}
                        onClose={() => setInternalError(false)}
                    >
                        Internal Server Error
                    </MDBAlert>
                )}
                {AddNumbers && (
                    <PopupLoaderNew
                        // size="lg"
                        // className="modal-lg"
                        title={"Add Numbers"}
                        content={
                            <AddRemoveNumbers
                                selectedNum={targePhonenumbers ?? []}
                                setUpdatePHNum={setUpdatedPHnums}
                                setUpdateNumbersExecuted={setUpdatedPHnumsFlag}
                                onClose={toggleNumbers}
                                sourceNumber={availableAddNums}
                                ref={addNumberRef}
                                setIsloading={setisLoading}
                            />
                        }
                        onShow={setAddNumbers}
                        onClose={toggleNumbers}
                        onSave={handleClick}
                        isloading={isLoading}
                        flag={1}
                    />
                )}
                {successMessage && (
                    <>
                        <TopSuccess>
                            <TopMessage successMessage={successMessage} />
                        </TopSuccess>
                    </>
                )}
                {errorMessage && (
                    <MDBAlert
                        open
                        className="alert-center"
                        color="danger"
                        autohide
                        position="bottom-right"
                        delay={10000}
                    >
                        <i className="fas fa-times-circle me-3"></i>
                        <span className="alert-msg">{errorMessage}</span>
                    </MDBAlert>
                )}
                {
                    unassignFlag && (
                        <PopupLoader
                            title={"Unassign Phone Number"}
                            content={<UnassignPhNumbers poolId={PoolObjInfo.poolid} setRemovedSuccess={setRemovedSuccess} phoneNumber={delPhNumber} onClose={unassignTogglePopup} />}
                            //onShow={setUnassignFlag}
                            onClose={unassignTogglePopup}
                        />

                    )
                }
                {isDirty && (
                    <SaveChanges
                        onClose={onCloseChanges}
                        onSave={(e) => {
                            handleSubmit(onsaveChanges)();
                        }}
                    />
                )}
                {showWarning && (
                    <EditWarning
                        warningToggle={warningToggle}
                        setShowWarning={setShowWarning}
                        onOk={handleOk}
                    />
                )}

            </>
        </React.Fragment>
    )
}

